/* StartagCreator.js */

import RemixHelper from "../helpers/RemixHelper";
import PSO from "../services/PSO";

const randomIntFromInterval = (min, max) => { return Math.floor(Math.random() * (max - min + 1) + min) }

export const StartagCreator = async ({ un, al, text }) => {
  let startagExists = false;
  let startag = RemixHelper.generateStarTag(text);

  const response = await PSO.checkStarTagExists({
    un: un,
    al: al,
    rstag: startag,
    getusersuggested: 1
  });
  if (response && response.result) {
    if (response.result === 'success') {
      if (response.systemstartagexists && (response.systemstartagexists === 1 || response.systemstartagexists === '1')) {
        startagExists = true;
      }
      if (response.userstartagexists && (response.userstartagexists === 1 || response.userstartagexists === '1')) {
        startagExists = true;
      }
      if (startagExists) {
        // Getting the suggested startag
        if (response.usersuggestedstartag) {
          startag = response.usersuggestedstartag;
          startagExists = false;
        }
      }
    }
  }
  if (startagExists) {
    // Trying to generate a new startag with a random number at the end - local method
    const maxRandom = 999;
    const random = randomIntFromInterval(0, maxRandom);
    if (startag.length >= 23) {
      startag = startag.substring(0, startag.length - 4);
    }
    startag = `${startag}_${random}`;
  }

  return startag;
}
